module.exports = __webpack_public_path__ + "static/media/shop-white.cb79db01.svg";